import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListAlt from '@material-ui/icons/ListAlt';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardHeader from '@/components/material-ui-kit/components/Card/CardHeader';
import Warning from '@/components/material-ui-kit/components/Typography/Warning';
import styles from 'styles/jss/original/components/about/aboutFeatureSection';
import classNames from 'classnames';
import { useMedia } from 'react-use';
import LazyLoadImage from '@/components/common/ui/LazyloadImage';
import AboutFeature01Image from 'public/img/contents/about-feature01.jpg';
import AboutFeature02Image from 'public/img/contents/about-feature02.jpg';
import AboutFeature03Image from 'public/img/contents/about-feature03.jpg';

const IMAGE_HEIGHT_PC = 250;
const IMAGE_HEIGHT_SP = 220;

// @ts-expect-error
const useStyles = makeStyles(styles);

const featureList = [
  {
    image: AboutFeature01Image,
    icon: <ListAlt />,
    category: '献立',
    title: '狭いキッチンでも作れる献立',
    description:
      '料理をする人・料理をしない人それぞれに適した献立を提案します。\n料理をする人には、狭いキッチンを考慮した簡単かつ定番な料理献立を手順イメージもあわせて紹介します。\n料理をしない人には、コンビニやオンラインショップで購入可能な優れたチルド食品や冷凍食品をセレクトして紹介します。'
  },
  {
    image: AboutFeature02Image,
    icon: <WbIncandescentIcon />,
    category: 'アイデア',
    title: '狭い空間で役立つアイデア集',
    description:
      '料理の基本や狭い空間の活用方法など、料理や暮らしのヒントになるアイデアをお伝えします。\n「料理を始めたいけど何かしたら良いかわからない」「部屋をもっとおしゃれにしたい」といったお悩みをお持ちの方はぜひご覧ください。'
  },
  {
    image: AboutFeature03Image,
    icon: <ShoppingCartIcon />,
    category: 'ショッピング',
    title: '狭い空間でも活躍するアイテムの紹介',
    description:
      '様々な切り口で狭い空間でも活躍するアイテムを紹介します。\n料理だけでなくインテリアや整理整頓、リラックスなど様々な切り口でアイテムを取り上げていきます。\n気になるアイテムは販売サイトで購入もできます。'
  }
];

const AboutFeatureSection: React.FC = () => {
  const classes = useStyles();
  const isSp = useMedia('(max-width: 640px)');
  const [imageHeight, setImageHeight] = useState(IMAGE_HEIGHT_PC);
  useEffect(() => {
    if (isSp) setImageHeight(IMAGE_HEIGHT_SP);
  }, [isSp]);
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        {/* @ts-expect-error プロパティ「justify」は、タイプ「IntrinsicAttributes & Pick<InferProps<{ children.Requireable<ReactNodeLike>; className」に存在しません。*/}
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={10} md={10}>
            <h3 className={classes.title}>small dish が提供するもの</h3>
            {featureList.map((item, index) => {
              const isEven = index === 1;
              return (
                <Card plain blog className={classes.card} key={item.title}>
                  <GridContainer>
                    <GridItem
                      //@ts-expect-error
                      xs={12}
                      sm={5}
                      md={5}
                      className={classNames(isEven ? classes.orderEven : '')}
                    >
                      <CardHeader image plain>
                        <LazyLoadImage height={imageHeight}>
                          {(onLoad) => <img src={item.image} alt={item.title} onLoad={onLoad} />}
                        </LazyLoadImage>
                        <div className={classes.coloredShadow} />
                      </CardHeader>
                    </GridItem>
                    {/* @ts-expect-error */}
                    <GridItem xs={12} sm={7} md={7}>
                      <Warning>
                        <h6 className={classes.cardCategory}>
                          {item.icon} {item.category}
                        </h6>
                      </Warning>
                      <h4 className={classes.cardTitle}>{item.title}</h4>
                      <p className={classes.description}>
                        {item.description.split('\n').map((str, index) => (
                          <React.Fragment key={index}>
                            {str}
                            <br />
                          </React.Fragment>
                        ))}
                      </p>
                    </GridItem>
                  </GridContainer>
                </Card>
              );
            })}
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default AboutFeatureSection;
